import { useQuery } from "react-query";
import axiosBaseConfig from "../../../configs/axios/axios-base.config";

export const useGetRubbishes = (location) => {
	return useQuery(["rubbishes"], () => {
		return axiosBaseConfig.put("shared/dynamicPriceV2", { location }).then((res) => res.data);
	});
};
